import { Form, Formik } from "formik";
import Auth from "src/Auth";
import { useToast } from "src/components/ToastWrapper/index.js";
import Editor from "./Editor";
import RightBar from "./RightBar";
import SubmitButton from "./SubmitButton";
import VersionHeader from "./VersionHeader";
import { useWorkflowStore } from "./workflowStore";

function VersionEditor({ workflowId, versionId }) {
  const workflow = useWorkflowStore((state) => state.workflows[workflowId]);
  const updateWorkflow = useWorkflowStore((state) => state.updateWorkflow);

  const version = workflow.versions.find((v) => v.id === versionId);

  const { setToast } = useToast();
  if (!version) {
    return null;
  }

  const handleSubmit = async (values) => {
    try {
      const result = await Auth.fetchWithIdToken(`/api/workflows/${workflowId}/versions/${versionId}`, {
        method: "POST",
        definition: values,
      });
      updateWorkflow(result.workflow);
      setToast("Workflow saved successfully");
    } catch (error) {
      console.error("Error submitting form:", error);
      setToast("Error saving workflow");
      throw error;
    }
  };

  return (
    <Formik
      initialValues={version.definition}
      onSubmit={handleSubmit}
    >
      <Form className="w-full mt-3">
        <div className="flex flex-row gap-4">
          <div className="flex gap-4 flex-col w-full grow">
            <div className="flex justify-between items-center w-full">
              <VersionHeader
                workflowId={workflowId}
                version={version}
              />
              <SubmitButton version={version} />
            </div>
            <Editor workflow={workflow} />
          </div>
          <RightBar
            workflow={workflow}
            version={version}
          />
        </div>
      </Form>
    </Formik>
  );
}

export default VersionEditor;
